var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-image",class:{'is-empty': !_vm.url}},[(_vm.url)?_c('lazy-image',{attrs:{"description":_vm.description,"url":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }